import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon77: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 20.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 20 20" width={width} height={height} {...props}>
      <Path
        d="M7.50025 9C7.77625 9 8.00025 9.2239 8.00025 9.5V17.5C8.00025 17.7762 7.77625 18 7.50025 18C7.22425 18 7.00025 17.7762 7.00025 17.5V9.5C7.00025 9.2239 7.22425 9 7.50025 9ZM12.5003 6.00002C12.7763 6.00002 13.0003 6.22388 13.0003 6.50002V17.5C13.0003 17.7762 12.7763 18 12.5003 18C12.2243 18 12.0003 17.7762 12.0003 17.5V6.50002C12.0003 6.22388 12.2243 6.00002 12.5003 6.00002ZM17.5003 5.00002C17.7763 5.00002 18.0003 5.22388 18.0003 5.50002V17.5C18.0003 17.7762 17.7763 18 17.5003 18C17.2243 18 17.0003 17.7762 17.0003 17.5V5.50002C17.0003 5.22388 17.2243 5.00002 17.5003 5.00002ZM2.50025 11C2.77625 11 3.00025 11.2239 3.00025 11.5V17.5C3.00025 17.7762 2.77625 18 2.50025 18C2.22425 18 2.00025 17.7762 2.00025 17.5V11.5C2.00025 11.2239 2.22425 11 2.50025 11ZM19.8903 0.18767C20.0633 0.4033 20.0283 0.71795 19.8123 0.89045L14.8123 4.89045C14.6423 5.02647 14.4042 5.03682 14.2232 4.91604L11.5443 3.13011L7.33225 6.87372C7.15025 7.03557 6.87824 7.04264 6.68824 6.89045L4.53724 5.17002L0.854258 8.8536C0.658258 9.0488 0.34225 9.0488 0.14625 8.8536C-0.04875 8.6583 -0.04875 8.3417 0.14625 8.1465L4.14625 4.14646C4.32725 3.96631 4.61327 3.95043 4.81227 4.10958L6.98326 5.84613L11.1683 2.12631C11.3383 1.97527 11.5883 1.95788 11.7773 2.08399L14.4732 3.88119L19.1882 0.10958C19.4032 -0.0629195 19.7183 -0.0279596 19.8903 0.18767ZM0.500254 20H19.5003C19.7763 20 20.0003 19.7762 20.0003 19.5C20.0003 19.2239 19.7763 19 19.5003 19H0.500254C0.224254 19 0.000253901 19.2239 0.000253901 19.5C0.000253901 19.7762 0.224254 20 0.500254 20Z"
        fill="#404040"
      />
    </Icon>
  )
}
